/* eslint-disable graphql-relay-compat/no-apollo-components -- This file uses Query apollo component to create the apollo-relay component shim */
import React from 'react';
import type { OperationVariables } from '@apollo/react-common';
import { Query, type QueryComponentOptions } from 'react-apollo';

import { expValEquals } from '@confluence/feature-experiments';

import { useQueryInterop } from './useQueryInterop';

export function QueryInteropImpl<TData = any, TVariables = OperationVariables>({
	children,
	query,
	...props
}: QueryComponentOptions<TData, TVariables>): JSX.Element | null {
	const result = useQueryInterop(query, props);
	return children(result);
}

export function QueryInterop<
	TData = any,
	TVariables extends OperationVariables = OperationVariables,
>(props: QueryComponentOptions<TData, TVariables>): JSX.Element | null {
	return expValEquals('confluence_deprecate_apollo_components', 'isEnabled', true) ? (
		<QueryInteropImpl<TData, TVariables> {...props} />
	) : (
		<Query<TData, TVariables> {...props} />
	);
}
